<template>
    <div class="top_rated container py-5">
        <div class="d-flex flex-row justify-content-between pb-5">
            <div class="d-flex flex-row gap-3">
                <div class="d-flex flex-column">
                    <h3 class="">Frequent Questions</h3>
                    <p class="">Something urgent to ask?</p>
                </div>
                <div class="d-flex flex-column">
                    <img src="@/assets/images/faq-chat.svg" width="64" />
                    <a class="">Chat with us</a>
                </div>
            </div>
            <div class="d-flex align-items-center">
                <button type="button" class="btn btn-outline-primary ft-14">See more FAQs</button>
            </div>

        </div>
        <div class="d-flex flex-row row pb-5">
            <div class="text-left col-6">
                <h3 class=" ft-16 pb-2">Do I need to pay to use Shelter?</h3>
                <p class=" w-75 ft-14">The story of Community Gothic with the san serif jobbing typefaces of the ninteenth century. These typefaces were clear and durablel, while often being coarse and even awkward. In many cases they were developed in isolation, withut any deliberate relationship to each other.</p>
            </div>
            <div class="text-left col-6">
                <h3 class=" ft-16 pb-2">Subscription, payments & renewals?</h3>
                <p class=" w-75 ft-14">The story of Community Gothic with the san serif jobbing typefaces of the ninteenth century. These typefaces were clear and durablel, while often being coarse and even awkward. In many cases they were developed in isolation, withut any deliberate relationship to each other.</p>
            </div>
        </div>
        <div class="d-flex flex-row row pb-5">
            <div class="text-left col-6">
                <h3 class=" ft-16 pb-2">How does Shelter work?</h3>
                <p class=" w-75 ft-14">The story of Community Gothic with the san serif jobbing typefaces of the ninteenth century. These typefaces were clear and durablel, while often being coarse and even awkward. In many cases they were developed in isolation, withut any deliberate relationship to each other.</p>
            </div>
            <div class="text-left col-6">
                <h3 class=" ft-16 pb-2">Should I visit the place before booking?</h3>
                <p class=" w-75 ft-14">The story of Community Gothic with the san serif jobbing typefaces of the ninteenth century. These typefaces were clear and durablel, while often being coarse and even awkward. In many cases they were developed in isolation, withut any deliberate relationship to each other.</p>
            </div>
        </div>
        <div class="bg-grey">
            <div class="container px-5 ">
                <div class="d-flex flex-column flex-md-row justify-content-between align-items-center gap-4 gap-md-0">
                    <div class="text-center text-md-start">
                        <h3 class=" mb-2 mb-md-3">Easy renting, without troubles</h3>
                        <p class=" mb-3 mb-md-0">Flexible payments, no Agent fees, Nationwide properties</p>
                    </div>
                    <div class="d-none d-sm-block">
                        <img src="@/assets/images/house-clouds.svg"
                             alt="Easy renting illustration"
                             class="img-fluid rental-image"
                             style="max-width: 250px; height: auto;">
                    </div>
                    <button type="button"
                            class="btn btn-cta btn-cta--small h-auto py-2 fs-16">
                        Sign up today
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>
<style>
    .bg-grey {
        background-color: #D9D9D9;
        border-radius: 10px;
    }

    .mp-width {
        width: 280px;
    }
</style>
<script>

</script>
